import classNames from 'classnames';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { closeSession } from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getResponseError } from '../../../utils/utils';

export default function SessionModalClose(props) {
  const dispatch = useDispatch();
  const {
    control, getValues,
  } = useForm({ defaultValues: { reason: '' } });
  const { loadData = () => {}, setShowCloseModal = () => {}, showCloseModal } = props;

  const handleCloseSession = event => {
    if (!showCloseModal?.id) {
      return;
    }

    const reasonRaw = getValues('reason');
    const reason = typeof reasonRaw === 'string' ? reasonRaw.trim() : '';

    const pool = {};
    if (reason) {
      pool.reason = reason;
    }

    dispatch(closeSession({
      pool,
      id: showCloseModal.id,
    })).then(() => {
      successNotification('Отмена сессии', 'Сессия отменена');
      loadData();
    }).catch(response => errorNotification('Отмена сессии', getResponseError(response)));

    setShowCloseModal(false);
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Dialog
      className={classNames('slp-close-modal')}
      size="xl"
      onClose={() => setShowCloseModal(false)}
      open
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            <div className="hff-title-text f2">Отмена сессии № {showCloseModal.id || 'Без номера'}</div>
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={() => setShowCloseModal(false)} />
            </div>
          </>
                )}
      />
      <DialogContent className="hff-content">
        <FieldDTO
          control={control}
          type="text"
          component={TextInputWithLabel}
          withLabel
          dtoObject={{
            name: 'reason',
            type: String,
            validators: [],
            labelKey: 'slp.reason',
          }}
          variant="material"
        />
      </DialogContent>
      <DialogFooter>
        <Button onClick={handleCloseSession}>Отменить сессию</Button>
      </DialogFooter>
    </Dialog>
  );
}
